module.exports = __webpack_public_path__ + "static/gordon-ramsay-makes-it-easy-781e2971a1a5c4d082935fc18e1047fb.jpg";